module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[101]222.b82a08b.woff2";